module.exports = [{
      plugin: require('../../../node_modules/gatsby-plugin-react-helmet-canonical-urls/gatsby-browser.js'),
      options: {"plugins":[],"siteUrl":"https://toggl.com"},
    },{
      plugin: require('../../toggl/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
